import { Controller } from '@hotwired/stimulus'

export default class ShowHideFieldsController extends Controller {
  static values = {
    triggerValues: Array
  }

  static targets = ['hiddenWrapper', 'input', 'selectInput', 'message', 'radioInput']

  connect() {
    if (this.hasInputTarget) {
      this.manageCheckboxInputChange(this.inputTarget.checked)
    }
    if (this.hasSelectInputTarget) {
      this.manageSelectInputChange(this.selectInputTarget.value)
    }
    if (this.hasRadioInputTarget) {
      const checkedRadio = this.radioInputTargets.find(radio => radio.checked)
      this.manageSelectInputChange(checkedRadio.value)
    }
  }

  handleSelectInputChange({ target }) {
    this.manageSelectInputChange(target.value)
  }

  manageSelectInputChange(input) {
    if (this.hasHiddenWrapperTarget){
      if (this.triggerValuesValue.map(String).includes(input)) {
        this.hiddenWrapperTargets.forEach((hiddenWrapper) => hiddenWrapper.classList.remove('d-none'))
      } else {
        this.hiddenWrapperTargets.forEach((hiddenWrapper) => hiddenWrapper.classList.add('d-none'))
      }
    }
  }

  handleRadioInputChange({ target }) {
    this.manageSelectInputChange(target.value)
  }

  handleCheckBoxInputChange({ target }) {
    this.manageCheckboxInputChange(target.checked)
  }

  manageCheckboxInputChange(input) {
    if (input === true) {
      this.hiddenWrapperTargets.forEach((hiddenWrapper) => hiddenWrapper.classList.add('d-none'))
      if (this.hasMessageTarget) {
        this.displayMessage(true)
      }
    }
    else {
      this.hiddenWrapperTargets.forEach((hiddenWrapper) => hiddenWrapper.classList.remove('d-none'))
      if (this.hasMessageTarget) {
        this.displayMessage(false)
      }
    }
  }

  displayMessage(input) {
    if (input === true) {
      this.messageTarget.classList.remove('d-none')
    }
    else {
      this.messageTarget.classList.add('d-none')
    }
  }
}
